import { render, staticRenderFns } from "./secondLevel.vue?vue&type=template&id=092525b9&scoped=true&"
import script from "./secondLevel.vue?vue&type=script&lang=js&"
export * from "./secondLevel.vue?vue&type=script&lang=js&"
import style0 from "./secondLevel.vue?vue&type=style&index=0&id=092525b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092525b9",
  null
  
)

export default component.exports